import React from 'react'
import { Avatar, Button, Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material'
import { Edit } from '@mui/icons-material'
import MarkerIcon from '../../images/airportMarker.svg'
import DeleteButton from '../_library/DeleteButton'
import { AIRPORT_COLLECTION } from '../../_constants/globals'
import { useFirestore } from '../../hooks/useFirestore'
import PropTypes from 'prop-types'


export const AirportCard = ({ airport, setEditMode }) => {
  
  const airportHooks = useFirestore(AIRPORT_COLLECTION)
  
  return (
    <Card sx={{ my: 2 }}>
      <CardHeader
        avatar={<Avatar alt='airport' src={MarkerIcon} />}
        title={airport.name}
        subheader={airport.ICAO}
        sx={{ bgcolor: 'grey.200' }}
      />
      <CardContent>
        <Typography variant='h4'>Location</Typography>
        <Typography>City : {airport.city}</Typography>
        <Typography>Country : {airport.country}</Typography>
        <Typography>Latitude : {airport.latitude}</Typography>
        <Typography>Longitude : {airport.longitude}</Typography>
        <Typography>Altitude : {airport.altitude}</Typography>
      </CardContent>
      <CardActions sx={{ float: 'right' }}>
        <Button onClick={() => setEditMode(true)}>
          <Edit />
        </Button>
        <DeleteButton
          deleteAction={() => airportHooks.deleteDoc(airport.id)}
          sx={{ color: 'error.main' }}
        />
      </CardActions>
    </Card>
  )
}

AirportCard.propTypes = {
  airport: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
}

export default AirportCard
